import React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";

import ActivitySource from "./ActivitySource";
import ImageComponent from "../../common/ImageComponent";

import appStyles from "../../../appStyles";

export default function TimeslotPendingData({ timeslot, journalContext }) {
  const { swapCurrentActivity, onTimeslotSelected, openMenuOptions } =
    journalContext || {};
  const { activity } = timeslot;

  const onPress = () => {
    // On journal page
    if (onTimeslotSelected) {
      onTimeslotSelected(timeslot);

      // On Edit page
    } else if (swapCurrentActivity) {
      swapCurrentActivity(timeslot.activity);
    }
  };

  const onLongPress = () => {
    openMenuOptions(timeslot);
  };

  return (
    <TouchableOpacity style={appStyles.timeslot} onPress={onPress}>
      <ImageComponent
        styles={appStyles.activityIcon}
        icon={timeslot.activity.icon}
        onPress={onPress}
        onLongPress={onLongPress}
      />

      {/* <ActivityColor color={activity.color} /> */}

      <View style={[appStyles.flex1]}>
        <Text style={[styles.activityName]}>{activity.name}</Text>
      </View>

      {timeslot.autoconfirmed ? (
        <ActivitySource source={timeslot.auto_fill_source} showIconContainer />
      ) : null}
      {/*       {!editMode && timeslot.user_confirmed ? (
        <View style={appStyles.flex}>
          <Icons.Journal
                styles={[styles.icon, { marginRight: 10 }]}
                onPress={() => openJournalDialog(timeslot)}
              /> 
          <Icons.Undo
            style={[appStyles.iconContainer]}
            onPress={() => onActivitySelected({}, false, false, false, null)}
          />
        </View>
      ) : null} */}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  activityName: {
    fontWeight: "500",
    fontStyle: "italic",
    fontSize: 12,
    lineHeight: 11,
    color: "#2D3142",
    letterSpacing: 0.175,
    paddingLeft: 10,
  },
});
